import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogClose } from "../UI/dialog";
import { Button } from "../UI/button";
import { Eye, EyeOff, X, Check, Copy, Info } from "lucide-react";
import { useState } from "react";
import {
    Select,
    SelectContent,
    SelectTrigger,
    SelectItem,
    SelectValue,
} from "../UI/select";
import { BsFillInfoSquareFill } from "react-icons/bs";
import { FaInfo } from "react-icons/fa6";
import { Input } from "../UI/input";
import apiService from "../../Services/APIService";

export default function IntegrationSetConfigDialog({ open, onOpenChange, integration, threadInfo }) {
    const [mobileNumber, setMobileNumber] = useState("");
    const [key, setKey] = useState("");
    const [version, setVersion] = useState("V2");
    const [showKey, setShowKey] = useState(false);
    const link = "https://biziverse.com/External.asmx/setIMLead?mob=2100000032";

    const handleCopy = () => {
        navigator.clipboard.writeText(link);
    };

    const handleSetApiConfig = async () => {
        if (!key || !mobileNumber) {
            return;
        }

        try {
            const payload = {
                changeType: "IMRT",
                key: "",
                value: "",
                extraValues: JSON.stringify({
                    imKey: key,
                    imMobile: mobileNumber,
                    imVersion: version,
                }),
            };
            const result = await apiService.sendChange(3, 'setIntgn', payload, { isWeb: true });
        } catch (error) {
        }
    };
    if (!integration) return null;


    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-md w-full pb-2 gap-0">
                <DialogHeader className="flex items-center justify-between">
                    <DialogTitle>{integration.name} Configuration</DialogTitle>
                    <DialogClose className="p-1 hover:bg-gray-100 sahi-radius-md">
                        <X className="h-5 w-5" />
                    </DialogClose>
                </DialogHeader>

                <div className="space-y-4 px-4 pb-4">
                    {integration.name === "IndiaMart" && (
                        <>
                            <div className="flex items-center gap-2">
                                <p className="text-sahi-primary-color font-bold text-sm">
                                    Manual Lead Import (PULL)
                                </p>
                                <Button className="w-5 h-5 p-2" >
                                    <FaInfo className="w-3 h-3" />
                                </Button>
                            </div>
                            {/* Mobile + Version */}
                            <div className="flex flex-row gap-2">
                                <div className="flex-1">
                                    <label className="block text-sm font-medium mb-1">Mobile</label>
                                    <Input
                                        type="text"
                                        value={mobileNumber}
                                        onChange={(e) => setMobileNumber(e.target.value)}
                                        className="w-full border p-2 sahi-radius sahi-input"
                                        placeholder="e.g. 8795487548"
                                    />
                                </div>
                                <div className="w-24">
                                    <label className="block text-sm font-medium mb-1">Version</label>
                                    <Select value={version} onValueChange={setVersion}>
                                        <SelectTrigger className="h-11">
                                            <SelectValue placeholder="Select Version" />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="V1">V1</SelectItem>
                                            <SelectItem value="V2">V2</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                            </div>

                            {/* Key */}
                            <div>
                                <label className="block text-sm font-medium mb-1">Key</label>
                                <div className="flex items-center w-full border rounded-md overflow-hidden bg-white text-sm">
                                    <Input
                                        type={showKey ? "text" : "password"}
                                        value={key}
                                        onChange={(e) => setKey(e.target.value)}
                                        className="w-full p-2 pr-10 sahi-radius sahi-input rounded-r-none"
                                        placeholder="e.g. 94e24217-28c9-4b2c-8e6c-abc123456789"
                                    />
                                    <button
                                        type="button"
                                        className="sahi-input-sidebutton"
                                        onClick={() => setShowKey(!showKey)}
                                    >
                                        {showKey ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                                    </button>
                                </div>
                            </div>

                            {/* Push URL */}
                            <div>
                                <div className="flex flex-col gap-1 mb-1">
                                    <p className="text-sahi-primary-color font-bold text-sm">
                                        Auto Lead Delivery (PUSH)
                                    </p>
                                    <span className="text-xs font-normal text-sub-text-color ">
                                        Make sure your IndiaMART plan supports real-time lead delivery. Share the link below with support to enable push integration.
                                    </span>
                                </div>
                                <div className="flex items-center w-full border rounded-md overflow-hidden bg-white text-sm">
                                    <Input
                                        value={link}
                                        readOnly
                                        className="w-full p-2 pr-10 sahi-radius sahi-input rounded-r-none"
                                        placeholder="e.g. 94e24217-28c9-4b2c-8e6c-abc123456789"
                                    />
                                    <button
                                        onClick={handleCopy}
                                        className="sahi-input-sidebutton"
                                        type="button"
                                    >
                                        <Copy size={16} />
                                    </button>
                                </div>
                            </div>

                            <Button
                                onClick={handleSetApiConfig}
                                className="w-full mt-4">
                                <Check className="h-5 w-5" />
                                Update Configuration
                            </Button>
                        </>
                    )}

                    {integration.name !== "IndiaMart" && (
                        <div className="text-muted-foreground">
                            No configuration UI defined for <strong>{integration.name}</strong>.
                        </div>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
}
